// extracted by mini-css-extract-plugin
export default {"component":"StepButtons_component__8mhdi","terms":"StepButtons_terms__7A5i9","buttons":"StepButtons_buttons__ZOcyE"};